import React, { useMemo, useState } from "react";
import styled from "styled-components";
import moment from "moment";
import { returnEuroString } from "../../../../../../helpers/Utils";
import { shipment_types_options } from "../../../../../../helpers/GlobalOptions";
import { ClassicButtonOutline } from "../../../../ButtonWithLoading";
import { FaTrash } from "react-icons/fa";
import { removeShipmentBeforeCalled } from "../../../../../../redux/Actions/shipmentsAction";
import { useDispatch } from "react-redux";
import useFetch from "../../../../../../hooks/useFetch";
import { getParcelTerminal } from "../../../../../../redux/Actions/parcelTerminalAction";
import { useSelector } from "react-redux";

function ShippingInformation({ information, mode, orderId }) {
  const { parcel_terminals } = useSelector((state) => state.options);
  const dispatch = useDispatch()
  const parcelTerminalName = useMemo(() => {
    if (!information.shipment_address.parcel_terminal_id) return null;
    return dispatch(getParcelTerminal(information.shipment_address.parcel_terminal_id))?.label
  }, [information.shipment_address.parcel_terminal_id, parcel_terminals])

  const additionalServices = useMemo(() => {
    let additionalServices = [];

    information.shipment_additional_services.forEach((item) => {
      const key = item.service_key;
      const value = item.service_value;
      if (key == "delivery") {
        if (value == "dpd_b2c") {
          additionalServices.push("B2C shipment (for private person)");
        } else if (value == "dpd_postMachine") {
          additionalServices.push("Delivery of goods via DPD parcel terminal");
        } else if (value == "omniva_home") {
          additionalServices.push("Home delivery");
        } else if (value == "omniva_postMachine") {
          additionalServices.push("Delivery of goods via OMNIVA parcel terminal");
        } else if (value == "lp_express_postMachine") {
          additionalServices.push(
            "Delivery of goods via LP_EXPRESS parcel terminal"
          );
        } else if (value == "lp_express_home") {
          additionalServices.push("Home delivery");
        } else if (value == "venipak_home") {
          additionalServices.push("Home delivery");
        } else if (value == "venipak_postMachine") {
          additionalServices.push("Delivery of goods via Venipak parcel terminal");
        } else if (value == "posti_home") {
          additionalServices.push("Home delivery");
        } else if (value == "posti_postMachine") {
          additionalServices.push("Delivery of goods via Posti parcel terminal");
        } else if (value == "itella_home") {
          additionalServices.push("Home delivery");
        } else if (value == "itella_postMachine") {
          additionalServices.push("Delivery of goods via Itella parcel terminal");
        } else if (value == "matkahuolto_home") {
          additionalServices.push("Home delivery");
        } else if (value == "matkahuolto_postMachine") {
          additionalServices.push("Delivery of goods via Matkahuolto parcel terminal");
        } else if (value == "zipasgo_home") {
          additionalServices.push("Home delivery");
        } else if (value == "zipasgo_postMachine") {
          additionalServices.push("Delivery of goods via ZipasGo parcel terminal");
        } else if (value == "siuntu_pilotai_home") {
          additionalServices.push("Home delivery");
        }
      }
      if (key === "time" && !!value) {
        additionalServices.push(`Delivery time: ${value}`);
      }
      if (key === "cod" && !!value) {
        additionalServices.push(`COD: ${returnEuroString(value)}`);
      }
      if (key === "order_return" && value == 1) {
        additionalServices.push("Pickup from the customer");
      }
      if (key == "sat" && value == 1) {
        additionalServices.push("Delivery on Saturday");
      }
      if (key == "delivery_same_day" && value == 1) {
        additionalServices.push("Same day delivery");
      }
      if (key == "docret" && value !== "0") {
        additionalServices.push(`Documents to be sent: ${value}`);
      }
      if (key == "carrying" && value == 1) {
        additionalServices.push("Carrying");
      }
      if (key == "recycle" && value == 1) {
        additionalServices.push("Recycle");
      }
      if (key == "connect" && value == 1) {
        additionalServices.push("Connect");
      }
      if (key == "swap" && value == 1) {
        additionalServices.push("SWAP");
      }
      if (key == "pack" && value > 0) {
        additionalServices.push(`${value} packages`);
      }
      if (key == "weight" && value > 0) {
        additionalServices.push(`Weight: ${value} kg`);
      }
      if (key == "lp_express_sizes" && value !== null) {
        additionalServices.push(`Package size: ${value}`);
      }
      if (key == "delivery_after_18" && value) {
        additionalServices.push("Delivery after 18:00");
      }
      if (key == "shipping_price" && value) {
        additionalServices.push(
          `Shipping price (Attached to cod): ${returnEuroString(value)}`
        );
      }
      if (key == "cod_payment_price" && value) {
        additionalServices.push(
          `Waiting payment (Attached to cod): ${returnEuroString(value)}`
        );
      }
      if (key == "leasing_cod" && value) {
        additionalServices.push(
          `Leasing (Attached to cod): ${returnEuroString(value)}`
        );
      }
      if (key == "basic_cod" && value) {
        additionalServices.push(
          `Basic (Attached to cod): ${returnEuroString(value)}`
        );
      }
      if (key == "cart_rules" && value) {
        additionalServices.push(
          `Cart rules: ${value}`
        );
      }
      if (key == 'created_through' && value) {
        if (value == 'bulk_action') {
          additionalServices.push('Bulk action');
        }
      }
    });
    return additionalServices
  }, [information.shipment_additional_services])

  const orderTypeValue = (value) => {
    if (value == "at_the_store") {
      return `DPD - Withdrawal in the office`;
    } else if (value == "at_the_store_lp") {
      return `LP express - Withdrawal in the office`;
    } else if (value == "at_the_store_venipak") {
      return `Venipak - Withdrawal in the office`;
    }
    const findShipment = shipment_types_options.find((e) => e.value === value);
    if (findShipment) {
      return findShipment.label;
    } else {
      return "";
    }
  };

  const renderPickupAddress = () => {
    return (
      <React.Fragment>
        <UlElements>
          <li className="font-weight-bold">Address</li>
          <li className="li-font">{information.pickup_address.address}</li>
        </UlElements>
        {!!information.pickup_address.address2 && (
          <UlElements>
            <li className="font-weight-bold">Address 2</li>
            <li className="li-font">{information.pickup_address.address2}</li>
          </UlElements>
        )}
        <UlElements>
          <li className="font-weight-bold">City</li>
          <li className="li-font">{information.pickup_address.city}</li>
        </UlElements>
        <UlElements>
          <li className="font-weight-bold">Postal code</li>
          <li className="li-font">{information.pickup_address.postal_code}</li>
        </UlElements>
        <br />
        <UlElements>
          <li className="font-weight-bold">Contact person</li>
          <li className="li-font">
            {information.pickup_address.contact_person}
          </li>
        </UlElements>
        {information.pickup_address.company !== null && (
          <UlElements>
            <li className="font-weight-bold">Company</li>
            <li className="li-font">{information.pickup_address.company}</li>
          </UlElements>
        )}
        {information.pickup_address.vat_code !== null && (
          <UlElements>
            <li className="font-weight-bold">VAT code</li>
            <li className="li-font">{information.pickup_address.vat_code}</li>
          </UlElements>
        )}
        {!!information.pickup_address.email && (
          <UlElements>
            <li className="font-weight-bold">Email</li>
            <li className="li-font">{information.pickup_address.email}</li>
          </UlElements>
        )}
        <UlElements>
          <li className="font-weight-bold">Phone</li>
          <li className="li-font">{information.pickup_address.phone}</li>
        </UlElements>
        <UlElements>
          <li className="font-weight-bold">Working hours</li>
          <li className="li-font">
            {information.pickup_address.pickup_time_from +
              " - " +
              information.pickup_address.work_time_to}
          </li>
        </UlElements>
        <br />
        <UlElements>
          <li className="font-weight-bold">Code</li>
          <li className="li-font"> {information.pickup_address.code}</li>
        </UlElements>
        {!!information.pickup_address.comment && (
          <UlElements>
            <li className="font-weight-bold">Comment</li>
            <li className="li-font">{information.pickup_address.comment}</li>
          </UlElements>
        )}
      </React.Fragment>
    );
  };

  const renderShippingAddress = () => {
    return (
      <React.Fragment>
        {information.shipment_address.parcel_terminal_id !== null && (
          <UlElements>
            <li className="font-weight-bold">Parcel terminal</li>
            <li className="li-font">
              {parcelTerminalName}
            </li>
          </UlElements>
        )}
        {information.shipment_address.country && (
          <UlElements>
            <li className="font-weight-bold">Country</li>
            <li className="li-font">
              {information.shipment_address.country.en_name}
            </li>
          </UlElements>
        )}
        <UlElements>
          <li className="font-weight-bold">Address</li>
          <li className="li-font">{information.shipment_address.address}</li>
        </UlElements>

        <UlElements>
          <li className="font-weight-bold">City</li>
          <li className="li-font">{information.shipment_address.city}</li>
        </UlElements>
        <UlElements>
          <li className="font-weight-bold">Postal code</li>
          <li className="li-font">
            {information.shipment_address.postal_code}
          </li>
        </UlElements>
        <br />
        <UlElements>
          <li className="font-weight-bold">Client</li>
          <li className="li-font">{information.shipment_address.name}</li>
        </UlElements>

        {information.shipment_address.company !== null && (
          <UlElements>
            <li className="font-weight-bold">Company</li>
            <li className="li-font">{information.shipment_address.company}</li>
          </UlElements>
        )}

        <UlElements>
          <li className="font-weight-bold">Email</li>
          <li className="li-font">{information.shipment_address.email}</li>
        </UlElements>

        <UlElements>
          <li className="font-weight-bold">Phone</li>
          <li className="li-font">{information.shipment_address.phone}</li>
        </UlElements>
        <br />

        <UlElements>
          <li className="font-weight-bold">Note from client</li>
          <li className="li-font">{information.shipment_address.comment}</li>
        </UlElements>
      </React.Fragment>
    );
  };

  return (
    <tr className="border" style={{ width: "100%", backgroundColor: "white" }}>
      <td colSpan="3" style={{ padding: "0.8rem 1.3rem" }}>
        <div className="d-flex">
          <div style={{ width: "48%" }}>
            <UlElements>
              <li className="font-weight-bold">Weight</li>
              <li className="li-font">{information.weight}</li>
            </UlElements>
            {information.picked_up_at && (
              <UlElements>
                <li className="font-weight-bold">Pickup Date</li>
                <li className="li-font">
                  {moment(information.picked_up_at).format("YYYY-MM-DD HH:mm")}
                </li>
              </UlElements>
            )}
          </div>
          <div style={{ width: "4%" }}></div>
          <div style={{ width: "48%" }}>
            <UlElements>
              <li className="font-weight-bold">Shipment type</li>
              <li className="li-font">
                {orderTypeValue(information.shipment_type)}
              </li>
            </UlElements>
            {information.delivered_at && (
              <UlElements>
                <li className="font-weight-bold">Delivery Date</li>
                <li className="li-font">
                  {moment(information.delivered_at).format("YYYY-MM-DD HH:mm")}
                </li>
              </UlElements>
            )}
          </div>
        </div>
        <br />
        <div className="d-flex">
          <div style={{ width: "48%" }}>
            {information.hasOwnProperty("pickup_address") && (
              <React.Fragment>
                <MainText>Pickup address</MainText>
                {additionalServices.includes("Pickup from the customer")
                  ? renderShippingAddress()
                  : renderPickupAddress()}
              </React.Fragment>
            )}
          </div>
          <div style={{ width: "4%" }}></div>
          <div style={{ width: "48%" }}>
            {information.hasOwnProperty("shipment_address") && (
              <React.Fragment>
                <MainText>Delivery address</MainText>
                {additionalServices.includes("Pickup from the customer")
                  ? renderPickupAddress()
                  : renderShippingAddress()}
              </React.Fragment>
            )}
          </div>
        </div>
        <br />
        <React.Fragment>
          <div className="d-flex">
            <div style={{ width: "48%" }}>
              {additionalServices.length > 0 && (
                <React.Fragment>
                  <MainText>Additional services</MainText>
                  <br />
                  {additionalServices.map((item, index) => {
                    return (
                      <div key={index}>
                        <UlElements>
                          <li className="li-font">{item}</li>
                        </UlElements>
                      </div>
                    );
                  })}
                </React.Fragment>
              )}
            </div>
            <div style={{ width: "2%" }}></div>
            <div style={{ width: "48%" }}>
              {information.courier_trackings.length > 0 && (
                <React.Fragment>
                  <MainText>Shipment tracking</MainText>
                  <br />
                  {information.courier_trackings.map(
                    (tracking_number, index) => (
                      <span key={index}>
                        <UlElements>
                          <li className="li-font">
                            <a href={tracking_number.url} target="_blank">
                              {tracking_number.number}
                            </a>
                          </li>
                        </UlElements>
                        <br />
                      </span>
                    )
                  )}
                </React.Fragment>
              )}
            </div>
          </div>
        </React.Fragment>
        {mode !== "create_index" && information?.can_be_deleted && information?.deleted_at == null && information?.service_order_type !== "ProductTransfer" && (
          <RemoveShippingInformation
            id={information.id}
            order_type={information.service_order_type}
            orderId={orderId || information.service_order_id || information.order?.id}
          />
        )}
      </td>
    </tr>
  );
}

const RemoveShippingInformation = ({ id, orderId, order_type }) => {
  const dispatch = useDispatch();
  const { value: its_valid } = useFetch(
    `/api/v1/orders/${orderId}/shipments/${id}/valid_destroy?order_type=${order_type}`
  );
  const [loading, setLoading] = useState(false);

  if (!its_valid) return null;

  const onSubmit = () => {
    setLoading(true);
    if (confirm("Are you sure want to delete the shipment?")) {
      dispatch(removeShipmentBeforeCalled(id, orderId, order_type));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <div className="d-flex justify-content-end align-items-center">
      <ClassicButtonOutline loading={loading} onClick={() => onSubmit()}>
        <FaTrash className="text-orange cursor-pointer" />
        <span className="ml-1">Remove</span>
      </ClassicButtonOutline>
    </div>
  );
};

const MainText = styled.h3`
  color: #000000;
  font-weight: 900;
  font-size: 1rem;
  line-height: 27px;
  color: #000000;
`;

const UlElements = styled.ul`
  margin-bottom: 8px;
  list-style-type: none;
  padding: 0px;
  li {
    word-wrap: break-word;
    font-size: 10px;
    line-height: 14px;
    color: #000000;
  }
  .li-font {
    font-size: 14px;
  }
`;

export default ShippingInformation;
